import { useEffect, useState } from "react";

const PopularEvents = ({currentId}) => {
    
    const storedData = sessionStorage.getItem('events');
    const initialEvents = storedData ? JSON.parse(storedData) : [];
    const [events, setEvents] = useState(initialEvents);
    const [popularEvents, setPopularEvents] = useState(initialEvents.slice(0, 5).filter(event => event._id !== currentId));

    useEffect(() => {
        if (!storedData) {
            fetch('https://al-maghrib-server.vercel.app/magazine/all')
                .then(res => res.json())
                .then(data => {
                    const reversedArray = data.magazines.reverse();
                    setEvents(reversedArray);
                    sessionStorage.setItem('events', JSON.stringify(reversedArray));
                })
        }
    }, [])

    return (
        <>
         <div>
              <h2 className="text-xl font-bold mb-4">Popular Articles</h2>
              <ul className="space-y-4">
              {popularEvents.length ? popularEvents.map((event, index) => (
                <li key={index}>
                  <a href={`https://almaghribschool.com/events/${event._id}`} className="text-blue-600 hover:underline">
                    {event.headline}
                  </a>
                </li>
              )) : null}
                
              </ul>
            </div>
        </>
    );
};

export default PopularEvents;